import { FormControl } from 'baseui/form-control'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddress from '../../useAddress'

const HotwaterEnergy = () => {
  const { t, updateAddress, hotwaterEnergy, hotwaterOptions } = useAddress()

  return (
    <FormControl>
      <SDSelect
        label={t('subscriptionTools:estimator.hot_water_mode.label')}
        optionsList={hotwaterOptions}
        onChangeHandler={params => updateAddress({ hotwaterEnergy: params.option?.id })}
        selectedValue={hotwaterEnergy ? hotwaterEnergy.toString() : ''}
        hasError={false}
      />
    </FormControl>
  )
}
export default HotwaterEnergy
